module.exports = __webpack_public_path__ + "media/images/home/main/aa/4-e2d22c44919d6e7ac2bc9a6e6b581312.png";